export default "__VITE_ASSET__cd6163ce__"